import type { Message } from '../types/chat';
import { conversationId } from './conversation';

/**
 * Log the full conversation to the server.
 * @param messages The full messages array to log
 */
export function logConversation(messages: Message[]): void {
    /**
     * The `isStreaming` property is not needed for logging.
     */
    const payload = messages.map(({ isStreaming, ...message }) => message);

    try {
        fetch(`/api/v1/chat/log/${conversationId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                workspace: window.chatConfig.workspace,
                messages: payload,
            }, (_key, value) => {
                if (value instanceof Error) {
                    return {
                        ...value,
                        message: value.message,
                        name: value.name,
                        stack: value.stack,
                    };
                }
                return value;
            }),
        });
    } catch (error: unknown) {
        console.error('Error logging conversation to server:', error);
    }
}

/**
 * Delete the current conversation from the server logs.
 * */
export function deleteConversation(): void {
    try {
        fetch(`/api/v1/chat/log/${conversationId}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
            }
        });
    } catch (error: unknown) {
        console.error('Error deleting conversation from server:', error);
    }
}
